var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbUpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.6668 14V5.3168l3.7168-3.6336c.2224-.2219.4696-.3552.7416-.4.2725-.0442.5253.0003.7584.1336.2336.1445.4003.3528.5.6248.1003.272.1115.5638.0336.8752l-.6168 2.4h4.1336c.3664 0 .6912.1416.9744.4248.2837.2832.4256.6083.4256.9752v1.3328a2.013 2.013 0 0 1-.0168.2504c-.0112.089-.0336.167-.0672.2336l-2 4.6664c-.0885.2336-.2523.4253-.4912.5752-.2389.1499-.4861.2248-.7416.2248H4.6668Zm1.4168-8.1v6.7h5.8832l1.9672-4.5504V6.7168H8.0004l.9168-3.6L6.0836 5.9ZM2.734 14c-.3888 0-.7195-.136-.992-.408-.272-.2725-.408-.6032-.408-.992V6.7168c0-.3888.136-.7195.408-.992.2725-.272.6032-.408.992-.408h1.9328l.0168 1.4H2.734V12.6h1.9496V14H2.734Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpIcon);
export default __webpack_public_path__ + "static/media/thumb-up-icon.abdc1186a734fc59b6040c3dcf7a5553.svg";
export { ForwardRef as ReactComponent };